import React, { useCallback, useState } from 'react';
import { Sequence, Audio } from 'remotion';
import { AudioLayerSegment } from '../../types/layers';

interface AudioSegmentProps {
  segment: AudioLayerSegment;
}

export const AudioSegment: React.FC<AudioSegmentProps> = ({ segment }) => {
  const [hasError, setHasError] = useState(false);

  const handleAudioError = useCallback((_error: Error) => {
    setHasError(true);
  }, []);

  if (segment.source.status === 'error' || segment.source.status === 'loading' || hasError) {
    return null;
  }

  if (segment.isMuted || segment.volume === 0) {
    return null;
  }

  const audioSeekFrame = segment.audioStartFrame || 0;

  return (
    <Sequence
      from={segment.startFrame}
      durationInFrames={segment.durationFrames}
    >
      <Audio
        src={segment.source.value}
        volume={segment.volume}
        startFrom={audioSeekFrame}
        pauseWhenBuffering
        onError={handleAudioError}
      />
    </Sequence>
  );
};
